export default {
  tokenInvalid: '访问令牌无效',
  placeholderInput: '请输入',
  placeholderSelect: '请选择',
  pleaseScan: '请扫描 ',
  productCode: '产品代号',
  productName: '产品名称',
  productSize: '产品尺码',
  sendStatus: '发送状态',
  taggingTime: '绑定时间',
  taggingDate: '绑定时间',
  search: '搜索',
  clear: '清空',
  close: '关闭',
  status: '状态',
  total: '总计',
  success: '操作成功',
  error: '操作失败',
  errorTitle: '错误',
  infoTitle: '通知',
  successTitle: '成功',
  warningTitle: '警告',
  confirmTitle: '确认',
  tagSuccess: '绑定成功',
  products: '产品',
  resendFailed: '重新发送失败',
  sendTime: '发送时间',
  sendDate: '发送时间',
  workStation: '操作台',
  operator: '操作者',
  sendFail: '发送失败行',
  sendSuccess: '发送成功行',
  sendTotal: '总行数',
  resend: '重发',
  download: '导出',
  isRequired: '是必填的',
  delete: '删除 ',
  addNew: '新增',
  add: '新增',
  edit: '编辑',
  channel: '渠道',
  plant: '仓库',
  rfidPlant: 'RFID 仓库',
  nfcPlant: 'NFC 仓库',
  tagType: 'Tag Type',
  tagTypeDesc: 'Tag Type描述',
  export: '导出查询结果',
  failureList: '导出最新失效SKU',
  exportAllInactiveSKU: '导出全部失效SKU',
  exportLatestActiveSKUList: '导出最新有效SKU',
  disable: '禁用',
  enable: '启用',
  disableMessage: '你确定这样操作吗',
  error404: '您访问的页面不存在。',
  errorAuth: '很抱歉！',
  errorTitle1: '您无权访问此页面。',
  errorTitle2: '请与管理员联系。',
  operation: '操作',
  columnsSettingTitle: '列展示',
  collapse: '折叠',
  expand: '展开',
  orderNumber: '订单号',
  all: '全选',
  upc: 'UPC',
  cartonNo: '箱号',
  qrCode: 'QR Code',
  waverunNo: '波次号',
  noDataExport: '无数据导出',
  sku: 'SKU',
  placeholderScanInput: '请输入或扫描',
  disableNfc: '作废',
  scanComplete: '扫描完成',
  backToScanning: '重返扫描',
  rfidEpc: 'RFID EPC',
  shipTo: 'Ship To',
  shipToName: 'Ship To 名称',
  lastUpdatedBy: '最后更新用户',
  lastUpdateTime: '最后更新时间',
  createTime: '创建时间',
  updateTime: '更新时间'
}
